
import { createTheme } from '@mui/material';

const commonComponents = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        fontFamily: "'Open Sans', sans-serif",
        transition: 'all 0.3s ease',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        textTransform: 'none',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
};

export const lightTheme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    h1: {
      background: 'linear-gradient(45deg, #2193b0, #6dd5ed)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    h2: {
      background: 'linear-gradient(45deg, #2193b0, #6dd5ed)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#2193b0',
      light: '#6dd5ed',
      dark: '#1c7a94',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF6B6B',
      light: '#ff8e8e',
      dark: '#ff4949',
    },
    background: {
      default: '#f8f9fa',
      paper: '#ffffff',
      gradient: 'linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%)',
    },
    text: {
      primary: '#2d3436',
      secondary: '#636e72',
    },
  },
  components: {
    ...commonComponents,
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(45deg, #2193b0, #6dd5ed)',
        },
      },
    },
  },
});

export const darkTheme = createTheme({
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    h1: {
      background: 'linear-gradient(45deg, #00f2fe, #4facfe)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    h2: {
      background: 'linear-gradient(45deg, #00f2fe, #4facfe)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
  },
  palette: {
    mode: 'dark',
    primary: {
      main: '#00f2fe',
      light: '#4facfe',
      dark: '#0056b3',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF6B6B',
      light: '#ff8e8e',
      dark: '#ff4949',
    },
    background: {
      default: '#1a1a1a',
      paper: '#2d2d2d',
      gradient: 'linear-gradient(to right, #141e30, #243b55)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
  },
  components: {
    ...commonComponents,
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(45deg, #141e30, #243b55)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(to right, #141e30, #243b55)',
          borderRadius: 12,
        },
      },
    },
  },
});
